import request from '~services/request';
export const UploadsPermissionsEmployeesAPI = {
    getAll: (filterParams, page, pageSize, sort) => request
        .get('/employee_policies', { params: { page, pageSize, sort, filterParams } })
        .then(response => response.data),
    update: (data) => request.post('/employee_policies/multi_insert_or_update', data)
};
